// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component } from 'vue-property-decorator';
import { AbstractSimpleModuleUi } from '../_abstract/ui';
/**
 * Component capable of rendering the `ListModule`'s contents.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
let ListModuleUi = class ListModuleUi extends AbstractSimpleModuleUi {
};
ListModuleUi = __decorate([
    Component({
        name: 'ListModuleUi',
        template: '<component :is="component" class="list-module" />'
    })
], ListModuleUi);
export { ListModuleUi };
